/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeclineTeamInviteBody
 */
export interface DeclineTeamInviteBody {
    /**
     * 
     * @type {string}
     * @memberof DeclineTeamInviteBody
     */
    inviteCode: string;
}

/**
 * Check if a given object implements the DeclineTeamInviteBody interface.
 */
export function instanceOfDeclineTeamInviteBody(value: object): value is DeclineTeamInviteBody {
    if (!('inviteCode' in value) || value['inviteCode'] === undefined) return false;
    return true;
}

export function DeclineTeamInviteBodyFromJSON(json: any): DeclineTeamInviteBody {
    return DeclineTeamInviteBodyFromJSONTyped(json, false);
}

export function DeclineTeamInviteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclineTeamInviteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteCode': json['inviteCode'],
    };
}

export function DeclineTeamInviteBodyToJSON(json: any): DeclineTeamInviteBody {
    return DeclineTeamInviteBodyToJSONTyped(json, false);
}

export function DeclineTeamInviteBodyToJSONTyped(value?: DeclineTeamInviteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inviteCode': value['inviteCode'],
    };
}

